import doctor from '../../../images/doctor-hands.png';

export const NpiTargeting = () => {
  return (
    <div
      style={{
        boxShadow: '0px 4px 20px -2px #32324714 ',
      }}
      className="max-w-[1064px] flex flex-col lg:flex-row items-center gap-[30px] p-[30px] xl:mt-[15%] mx-auto"
    >
      <img src={doctor} alt="doctor" />
      <div className="flex flex-col">
        <h1 className="text-[30px] font-[500]">
          Break Through Passive HCP Recruitment Barriers with NPI Targeting
        </h1>
        <p className="text-[18px]">
          Most hospitals miss passive HCPs. Discover how first-to-market
          NPI-targeted campaigns can scale your outreach and fill roles faster
          with qualified clinicians.
        </p>
        <a className="btn btn-secondary btn-lg" href='https://digividbio.com/blogs/attracting-passive-hcp-job-seekers-npi-targeted-campaign-strategies'>Go to Article</a>
      </div>
    </div>
  );
};
